import React, {useEffect, useState, useRef} from 'react';
import {Button, Input, Form, message} from "antd";
import {ArrowRightOutlined} from "@ant-design/icons";
import {useAuth0} from "../services/auth0";
import {createRequestAccess} from "../services/api.service";

const RequestAccess = () => {
    const [form] = Form.useForm();
    const [loader, setLoader] = useState(false);
    const {user, getTokenSilently} = useAuth0();
    const [token, setAuthToken] = useState(localStorage.accessToken);

    const instance = useRef(null);

    useEffect(() => {
        if (user) {
            setToken()
        }
    });

    const setToken = async () => {
        const data = await getTokenSilently();
        setAuthToken(data)
    };

    const onRequest = async (email) => {
        try {
            setLoader(true);
            await createRequestAccess({...email});
            form.resetFields();
            setLoader(false);
            message.success('Thank You! We have received your request and will notify you if you are granted access');
        } catch (err) {
            message.error('Fail to send request');
            setLoader(false);
        }
    };
    return (
        <React.Fragment>
            {!token ? (
                <Form
                    form={form}
                    name="requestAccess"
                    className="login-form"
                    onFinish={onRequest}>
                    <Input.Group compact className="request-access-input-group">
                        <Form.Item
                            name="email"
                            rules={
                                [
                                    {
                                        type: 'email',
                                        message: ' Please enter a valid email address',
                                    },
                                    {
                                        required: true,
                                        message: 'Please input your email address',
                                    },
                                ]
                            }
                        >
                            <Input className="email-filed" placeholder="Enter your email to request access"/>
                        </Form.Item>
                        <Button
                            shape="circle"
                            className="request-access"
                            type="primary"
                            htmlType="submit"
                            icon={<ArrowRightOutlined/>} loading={loader}/>
                    </Input.Group>
                </Form>
            ) : null}

        </React.Fragment>
    )
};
export default RequestAccess;